import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import axios from "axios";
import { getBackendBaseURL } from "./helper/config";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

axios.defaults.baseURL = getBackendBaseURL();

// Enable credentials for all requests to send cookies
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <BrowserRouter>

      <App />
    </BrowserRouter>
  </React.StrictMode>
);
// serviceWorkerRegistration.register();
